import React from "react"
import { Link, graphql } from "gatsby"

import Layout from "../components/layout"
import SEO from "../components/seo"
import SocialLinks from "../components/socialLinks"
import GetInTouch from "../components/getInTouch"
import Thoughts from "../components/thoughts"
import thoughts from "../data/thoughts"

const ThoughtsPage = ({ data }) => {
  const { pageData, svgFiles } = data
  const { home, thoughts: thoughtsPage } = pageData.siteMetadata.pages

  return (
    <Layout headerData={home} showThoughtsNav>
      <Link to="/music" className="ribbon slant-down">
        <div className="content">Music →</div>
      </Link>
      <SEO
        title={thoughtsPage.title}
        description={thoughtsPage.description}
        pathname="/thoughts/"
        keywords={[
          "Rahul Vagadiya",
          "product thinking",
          "AI",
          "building products",
        ]}
      />
      <SocialLinks
        svgFiles={svgFiles}
        links={pageData.siteMetadata.dev.links}
      />
      <GetInTouch />
      <hr />
      <Thoughts thoughts={thoughts} summary={thoughtsPage.description} />
      <Link className="thought-home-link" to="/">
        ← Back to home
      </Link>
    </Layout>
  )
}

export const query = graphql`
  query ThoughtsPageQuery {
    pageData: site {
      siteMetadata {
        pages {
          home {
            name
            description
          }
          thoughts {
            title
            name
            description
          }
        }
        dev {
          links {
            name
            url
            filename
            tooltip
            icon
          }
        }
      }
    }
    svgFiles: allFile(filter: { extension: { eq: "svg" } }) {
      edges {
        node {
          publicURL
          name
        }
      }
    }
  }
`

export default ThoughtsPage
